export default {
  "content": "<path d=\"M14.8 1.332v1.413c3.875 1.197 6.692 4.805 6.692 9.073 0 5.243-4.249 9.492-9.492 9.492s-9.492-4.249-9.492-9.492c0-4.268 2.817-7.876 6.692-9.073V1.332C4.564 2.567 1.15 6.794 1.15 11.818c0 5.992 4.857 10.85 10.85 10.85s10.85-4.858 10.85-10.85c0-5.024-3.414-9.251-8.05-10.486z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};